import React from "react";
import { useTranslation } from "react-i18next";

type Props = {
	userCore?: any;
};

const ManagedBar: React.FC<Props> = ({ userCore }: Props) => {
	const {t}=useTranslation();
	return userCore?.managed_by ? <div className="managed-by-section"><span>{t("managed_by_str")} <b>{userCore.managed_by.email}</b></span></div> : null;
};

export default ManagedBar;